import { generateId } from '@freelancer/datastore/testing/helpers';
import type { UserRestrictions } from './user-restrictions.model';

export interface GenerateUserRestrictionsOptions {
  readonly userIds: readonly number[];
  readonly isRestricted?: boolean;
}

export interface GenerateUserRestrictionOptions {
  readonly userId?: number;
  readonly isRestricted?: boolean;
}

export function generateUserRestrictionsObjects({
  userIds,
  isRestricted,
}: GenerateUserRestrictionsOptions): readonly UserRestrictions[] {
  return userIds.map(userId =>
    generateUserRestrictionsObject({ userId, isRestricted }),
  );
}

export function generateUserRestrictionsObject({
  userId = generateId(),
  isRestricted = false,
}: GenerateUserRestrictionOptions = {}): UserRestrictions {
  return {
    id: userId,
    isRestricted,
  };
}
